import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iday-profile',
  templateUrl: './iday-profile.component.html',
  styleUrls: ['./iday-profile.component.css']
})
export class IdayProfileComponent {
  class: string = 'active';
  previewbol: boolean = false;
  outagebol: boolean = true;
  loading: boolean = false;
  showimage: boolean = false;
  url1: any;
  url2: any;
  blob1: any;
  blob2:any;
  previewImage1: any;
  previewImage2: any;
  outageinputval: any = {};
  emails: any;
  statusAvailable: boolean = false;
  returndata: any;
  responseMessage: string = '';
  constructor(private http: HttpClient) {}

  preview(e: any) {
    e.preventDefault();
    this.previewbol = true;
    this.outagebol = false;
    console.log(this.outageinputval);
  }
  goback() {
    this.outagebol = true;
    this.previewbol = false;
  }

  email() {
    console.log(1);
    if (this.outageinputval.emailaccount == 'CEO') {
      this.emails = 'ceo@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'CPD') {
      this.emails = 'cpd@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'CIO') {
      this.emails = 'cio@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'CFO') {
      this.emails = 'cfo@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'CMO') {
      this.emails = 'cmo@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'CQA') {
      this.emails = 'cqa@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'CHRO') {
      this.emails = 'chro@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'CSO') {
      this.emails = 'cso@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'vinutha.naik') {
      this.emails = 'vinutha.naik@iday.maistering.com';
    } else if (this.outageinputval.emailaccount == 'benedict.alphonse') {
      this.emails = 'benedict.alphonse@iday.maistering.com';
    }
    console.log(this.emails);
  }
  sendemail(): void {
    this.getmethod();
  }

  image() {
    this.showimage = true;
  }
  getmethod() {
    // console.log(this.outageinputval.weblink)
    let formData = new FormData()
    formData.append("user_image" , this.url1)
    // formData.append("enterprise_image" , this.url2)
    formData.append("first_Name", this.outageinputval.firstname)
    formData.append("last_Name", this.outageinputval.lastname)
    formData.append("Enterprise_Name", this.outageinputval.enterprisename)
    formData.append("user_email", this.emails)
    this.loading = true;
    setTimeout(() => {
      console.log(1);
      // Call the setDelay function again with the remaining times
      this.loading = false;
    }, 2000);
    this.http
      .put(
        `https://mbvdevopsapi.maistering.com/iday/idayprofileupdate`,
        formData
      )
      .subscribe({
        next: (data: any) => {
          this.statusAvailable = true;
          this.returndata = data['status_code'];
          if (this.returndata == 200) {
            this.responseMessage = ': Profile Updated Successfully!, Please go ahead & click on Purge below';
          } else {
            this.responseMessage = ': Profile Updated Successfully!, Please go ahead & click on Purge below';
          }
        },
        error: (err) => {
          this.statusAvailable = true;
          this.responseMessage = ': Oops...! Something Went Wrong!';
        },
        complete: () => {},
      });
  }

  onFileChanged1(e: any) {
    let reader: any = new FileReader();
    if (e.target.files && e.target.files.length > 0) {
      let file = e.target.files[0];
      this.url1 = e.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        var data=reader?.result?.split(',')[1];
        var binaryBlob = atob(data);
        this.blob1 = binaryBlob;
        this.previewImage1 = reader.result;

      };
    }
  }
  onFileChanged2(e: any) {
    let reader:any = new FileReader();
    if (e.target.files && e.target.files.length > 0) {
      let file = e.target.files[0];
      this.url2= e.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        var data=reader?.result?.split(',')[1];
        var binaryBlob = atob(data);
        this.blob2 = binaryBlob;
        this.previewImage2 = reader.result;
      };
    }
  }

  onnclickpurge(){
    console.log("Button Purge")
    let URL = "https://mbvdevopsapi.maistering.com/iday/purge"
    this.http.post(URL, {}).subscribe(
      response => {
        this.statusAvailable = true;
        this.responseMessage = ': Profile Purged Successfully!, check profile after 5 minutes';
        console.log("Profile is Purged")
      },
      (err) => {
        this.statusAvailable = true;
        this.responseMessage = ': Oops...! Something Went Wrong!';
      },
    )
  }

}

